import React, {useEffect, useState} from "react";
import { Button, Popconfirm, Tooltip } from "antd";
import { openNotificationWithIcon } from "@frontend/src/utilities/notificationWithIcon";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import DragSortingTable from "../DragSortingTable";
import { DndProvider} from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { OrganizationDefaultColumnService } from '@frontend/src/core/services/organization_default_column_service'
import { ListService } from '@frontend/src/core/services/list_service'
import './DefaultColumns.scss'
import ModalAddStep from '../modal_add_step/ModalAddStep'
import ModalEditStep from '../modal_edit_step/ModalEditStep'

const DefaultColumns = ({
  default_columns,
  tenantId,
  organizationId,
}) => {
  const [showModal,setShowModal] = useState(null)
  const [categoryName,setCategoryName] = useState('')
  const [selectedColumn,setSelectedColumn] = useState(null)
  const [isCreating,setIsCreating] = useState(null)
  const [defaultColumns,setDefaultColumns] = useState(default_columns)
  const [isEditing,setIsEditing] = useState(null)
  const [isDeleting, setIsDeleting] = useState(null)
  const defaultColumnService = new OrganizationDefaultColumnService
  const listService = new ListService()
  const columnList = [
    {
      title: "Nombre de etapa",
      dataIndex: "name",
    },
    {
      dataIndex: "",
      align: "center",
      width: 90,
      fixed: "right",
      render: (record) => actions(record),
    },
  ];
  
  const actions = (column) => {
    return (
      <div className="actions">
        <span className="action-box">
          <Button
            type="link"
            className="icon-item"
            size="small"
            onClick={() => {
            setSelectedColumn(column);
            setShowModal(2);
            }}
          >
            <EditOutlined />
          </Button>
        </span>
        <span className="action-box">
          <Popconfirm
            title="¿Estás seguro de eliminar el motivo? (El motivo será eliminado de forma permanente)"
            onConfirm={() => deleteColumn(column)}
            onCancel={() => {}}
            okText="Eliminar"
            cancelText="Cancelar"
          >
            <Button type="link" className="icon-item" size="small">
            <DeleteOutlined />
            </Button>
          </Popconfirm>
        </span>
      </div>
    );
  };


  const showColumnModal = () => {
    if (showModal === 1) {
      return (
        <ModalAddStep
          organizationId={organizationId}
          isModalVisible={showModal===1}
          onCancelModal={() => setShowModal(null)}
          tenantId={tenantId}
          modalTitle="Crear nueva etapa"
        />
      )
    } else if (showModal === 2) {
      return (
        <ModalEditStep
          organizationId={organizationId}
          isModalVisible={showModal===2}
          columnId={selectedColumn.id}
          onCancelModal={() => setShowModal(null)}
          tenantId={tenantId}
          modalTitle={selectedColumn.name}
          column={selectedColumn}
        />
      )
    }
  }

  const onChangeState = (column, state) => {
    setSelectedColumn(column)
    setShowModal(state)
  }


  const deleteColumn = (column) => {
    defaultColumnService
      .delete(
        column.id,
        (success) => {
          window.location.reload(false);
          openNotificationWithIcon(
            "success",
            "Etapa eliminada correctamente",
            ""
          );
          return success
        },
        (error) => console.error(error))
  }

  const updateOrder = (data,id) => {
    defaultColumnService
      .edit(
        id,
        data,
        (success) => { return success },
        (error) => console.error(error))
  }

  useEffect(()=> {
    defaultColumnService
      .getAll(
        (success) => setDefaultColumns(success),
        (error) => console.error(error))
  }, [])

  useEffect(() => {
    if(isCreating){
      bringCategories()
      setIsCreating(null)
      setShowModal(null)
      setCategoryName('')
    }
  }, [isCreating])

  useEffect(() => {
    if(isDeleting){
      bringCategories()
      setIsDeleting(null)
    }
  }, [isDeleting])

  useEffect(() => {
    if(isEditing){
      bringCategories()
      setShowModal(null)
      setIsEditing(null)
    }
  }, [isEditing])

  const onClickSync = () => {
    listService.syncDefaults(success => {
      openNotificationWithIcon(
        "success",
        success.message,
        ""
      )
    }, _err => {})
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <div>
        <div className={'card settings-card'}>
          <div className='card-header'>
            <div className='title'>Orden de Etapas <span>Por defecto</span></div>
          </div>
          <div className='card-body'>
            <div>
              <div className="sync-action">
                <Tooltip title="Aplicar de forma retroactiva (al ejecutar esta acción, los procesos que estén activos, cuenten con candidatos o hayan sido generados desde una plantilla no se verán afectados)">
                  <Button shape="circle" icon="sync" onClick={onClickSync}/>
                </Tooltip>
              </div>
              <DragSortingTable
                columnList={columnList}
                dataList={defaultColumns}
                setDataList={setDefaultColumns}
                updateFunction={updateOrder}
              />
            </div>
            <div className='button-add'>
              <Button onClick={() => onChangeState(null,1)}>Crear nueva etapa</Button>
            </div>
          </div>
        </div>
        {showModal && showColumnModal()}
      </div>
    </DndProvider>
  )
}

export default DefaultColumns
